<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-Loading="isLoadingPage">
        <div slot="body">
          <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="alert alert-info">
                  <a> {{ message }} </a>
                </div>
              </div>
              <div class="row">
              <div class="col-6">
                <div class="widget style1 navy-bg" @click="onlineUserResult">
                      <div class="row">
                          <div class="col-4">
                              <i class="fa fa-user-plus fa-5x"></i>
                          </div>
                          <div class="col-8 text-right">
                              <span> تعداد رانندگان آنلاین </span>
                              <h2 class="font-bold">{{ this.reports && this.reports.clients ? this.reports.clients.length : 0 }}</h2>
                          </div>
                      </div>
                </div>
              </div>
              <div class="col-6">
                <div class="widget style1 red-bg" @click="offlineUserResult">
                      <div class="row">
                          <div class="col-4">
                              <i class="fa fa-user-minus fa-5x"></i>
                          </div>
                          <div class="col-8 text-right">
                              <span> تعداد رانندگان  آفلاین </span>
                              <h2 class="font-bold">{{ this.reports && this.reports.firebase ? this.reports.firebase.length : 0 }}</h2>
                          </div>
                      </div>
                  </div>
              </div>
              </div>
            </div>
            <div class="col-6">
              <div class="k-rtl">
                <chart
                  :chart-data="chart"
                  y-title="آمار هفتگی کاربران آنلاین"
                  category="created_at"
                  value="count"
                  height="300px"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <bita-grid
              v-if="showGrid"
              ref="grid"
              :columns="gridColumns"
              :read-data="readData"
              :hasRow="false"
              :resizable="true"
            />
          </div>
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
import Chart from "../../components/template/chart/AmColumnWithRoutatedSeries";
import axios from "axios";
export default {
  components: {Chart},
    data() {
        return {
            breadCrumbs: [
              {title: "صفحه اصلی", link: "/"},
              {title: "گزارش کاربران", link: "/user-report"},
            ],
            chart: {},
            reports: [],
            message : 'جهت نمایش کاربران هر قسمت برروی آیکون مورد نظر کلیک نمایید',
            showGrid: false,
            isLoadingPage: false,
        }
    },
    computed:{
      gridColumns(){
        return [
          { title: "#", template: this.$getTemplate, width: "40px" },
          { field: "full_name",title: "نام کاربر",template: (e) => (e.full_name ? e.full_name : " - ")},
          { field: "state",title: "وضعیت",template: (e) => (e.status ? e.status : " - ")},
          { field: "connection_info",title: "اطلاعات اتصال",template: (e) => (e.connection_info ? e.connection_info : " - ")},
          { field: "connected_at",title: "زمان اتصال",template: (e) => (e.connected_at ? e.connected_at : " - ")},
        ]
      } 
    },
    mounted() {
      this.getUserReports();
    },
    methods: {
      getUserReports() {
        let token = `bearer ${localStorage.getItem("token")}`;
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['Authorization'] = token;
        window.axios.defaults.baseURL = process.env.VUE_APP_NOTIFICATION_API;
        this.isLoadingPage = true;
        axios.get('api/notifications')
          .then( (res) => {
            this.reports = res.data;
          })
          .finally( () => this.isLoadingPage = false );
      },
      onlineUserResult() {
        this.showGrid = true;
      },
      offlineUserResult() {
        this.showGrid = true;
      },
      readData() {

      },
      loadData() {

      },
    }
}
</script>
<style scoped>
.widget {
  cursor: pointer !important;
}
</style>